import { render } from "./DifficultyPerformance.vue?vue&type=template&id=cd67a46c&scoped=true"
import script from "./DifficultyPerformance.vue?vue&type=script&lang=js"
export * from "./DifficultyPerformance.vue?vue&type=script&lang=js"

import "./DifficultyPerformance.vue?vue&type=style&index=0&id=cd67a46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd67a46c"]])

export default __exports__